import { useEffect, useState } from "react";
import { Button } from "../../../components/button/button";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useParams } from "react-router";
import { InputBlock } from "./InputBlock";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import KnowledgeAPI from "../../../api/KnowledgeAPI";
import { Spring } from "../../../components/spring/spring";

// import styles from "./addCategory.module.css";

export const SuperadminAddCategoryPage = () => {
    const { cafeId } = useParams();

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState(false);

    const [icon, setIcon] = useState(null);

    useEffect(() => {
        setNameError(false);
    }, [name]);

    const validateData = () => {
        let error = false;

        if (name.length <= 1) {
            setNameError(true);
            error = true;
        }

        return error;
    }

    const navigate = useAnimatedNavigate()
    const [loading, setLoading] = useState(false);
    const onSave = () => {
        if (validateData()) return;

        setLoading(true);
        KnowledgeAPI
            .createMaterial(
                name,
                cafeId,
            )
            .then(res => {
                if (icon) {
                    KnowledgeAPI
                        .uploadMaterialIcon(cafeId, res.materialId, icon)
                        .then(() => {
                            if (cafeId) {
                                navigate(`/superadmin/cafe/${cafeId}/knowledge/${res.materialId}`);
                            } else {
                                navigate(`/superadmin/knowledge/${res.materialId}`);
                            }
                        })
                } else {
                    if (cafeId) {
                        navigate(`/superadmin/cafe/${cafeId}/knowledge/${res.materialId}`);
                    } else {
                        navigate(`/superadmin/knowledge/${res.materialId}`);
                    }
                }
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }

    return (
        <>
            <AdminHeader title="Добавить категорию" />

            <InputBlock
                type="text"
                title="Введите название категории"
                value={name}
                setValue={setName}
                error={nameError}
            />

            <InputBlock
                type="file"
                title="Выберите изображение для категории"
                value={icon}
                setValue={setIcon}
                accept="image/*"
            />

            <Spring />

            <Button
                text="Добавить категорию"
                onClick={onSave}
                disabled={loading}
            />
        </>
    )
}
